var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages element-ui-pagination"},[_c('el-pagination',{staticClass:"pagess",attrs:{"background":"","layout":"prev, pager, next","total":_vm.pageData.total,"page-size":_vm.pageData.pageSize,"current-page":_vm.pageData.current,"hide-on-single-page":""},on:{"current-change":_vm.changeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }